<template>
<v-list-group v-model='active' >
  <template v-slot:activator>
    <v-list-tile :key='submission.id' class='no-pad-left pl-0' >
      <v-menu v-if='withActions' bottom >
        <template v-slot:activator="{ on }">
        <v-btn @click.stop='noop' v-on='on' slot='activator' small icon >
          <v-icon>more_vert</v-icon>
        </v-btn>
        </template>
        <v-list dense sub-header class='pa-0' >
          <v-subheader class="overline py-0 py-0 pr-0" >Actions
            <v-spacer></v-spacer>
            <v-btn icon small><v-icon small>close</v-icon></v-btn>
          </v-subheader>
          <v-divider></v-divider>
          <v-list-tile
            v-for='action in actions'
            v-bind='action.attrs'
            @click='action.onClick(action)'
            :disabled='action.isDisabled && action.isDisabled(action)'
            :key='action.title' >
            <v-list-tile-content>
              <v-list-tile-title v-text='action.title'>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <slot name ='list-tile-avatar' ></slot>
      <v-list-tile-avatar>
        <v-chip v-if='submission.new === "1"' dark color='success' class="v-chip--x-small" >New</v-chip>
        <v-chip v-if='submission.new === "0"' dark color='info' class="v-chip--x-small" >Read</v-chip>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          v-if='submission && submission.linked_submission && submission.linked_submission.relationship' >
            <!-- #{{ relationship.id }}. -->
            {{ submission.linked_submission.relationship.first_name }}
            {{ submission.linked_submission.relationship.last_name }}
        </v-list-tile-title>
        <v-list-tile-title
          v-else-if='relationship && relationship.id' >
            <!-- #{{ relationship.id }}. -->
            <template v-if='relationship && relationship.client' >
              {{ relationship.client.first_name }}
              {{ relationship.client.last_name }}
            </template>
        </v-list-tile-title>
        <v-list-tile-title v-else>
          Not assigned to client.
          <span v-if='getPotentialName(submission.answers)' >
            (maybe: {{ getPotentialName(submission.answers) }})
          </span>
        </v-list-tile-title>
        <v-list-tile-sub-title v-if='submission.created_at' >
          {{ dateformat(submission.created_at) }} at {{ (submission.created_at.split(" ")[1]) }}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title v-if='submission.created_date' >
          {{ dateformat(submission.created_date) }} at {{ (submission.created_date.split("T")[1]) }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <slot name ='list-tile-action' ></slot>
    </v-list-tile>
  </template>
  <form-submission-card
    v-if="active"
    v-model='submission'
    :submission-id='submission.id' />
</v-list-group>
</template>
<script>
import FormSubmissionCard from '@/components/cards/FormSubmissionCard'

export default {
  name: 'SubmissionListItem',
  components: {FormSubmissionCard},
  props: {
    item: { type: Object, default: () => { return {} } },
    expand: { type: Boolean, default: false },
    withActions: { type: Boolean, default: true }
  },
  data () {
    return {
      active: false,
      selected: false
    }
  },
  computed: {
    submission () {
      return this.item
    },
    relationship () {
      return this.getObjectPath(this.submission, 'linked_submission.relationship', {})
    },
    pdfLink () {
      // return `https://www.jotform.com/API/inbox/pdf-converter/${this.submission.form_id}/fill-pdf?submissionID=${this.submissionId}`
      // return `https://www.jotform.com/server.php?action=getSubmissionPDF&sid=${this.submission.id}&formID=${this.submission.form_id}`
      return 'https://www.jotform.com/pdf-submission/' + this.submission.id
    },
    inboxLink () {
      return `https://www.jotform.com/inbox/${this.submission.form_id}/${this.submission.id}`
    },
    actions () {
      return [
        {
          title: 'Show client',
          attrs: {},
          onClick: (action) => {
            if (this.relationship) {
              this.gotoRelationship(this.relationship.id, 1)
            }
          },
          isDisabled: () => {
            if (this.relationship && this.relationship.id) { return false }
            return true
          }
        },
        {
          title: 'Assign to client',
          onClick: () => {
            this.$emit('assign_client', this.submission)
          },
          isDisabled: () => {
            if (this.relationship && this.relationship.id) { return true }
            return false
          }
        },
        // {
        //   title: 'Sync to contact details',
        //   onClick: () => { },
        //   attrs: {}
        // },
        {
          title: 'Download PDF',
          attrs: {
            href: this.pdfLink,
            target: '_blank'
          }
        },
        {
          title: 'Open in JotForm inbox',
          attrs: {
            href: this.inboxLink,
            target: '_blank'
          }
        }
      ]
    }
  },
  watch: {
    expand: {
      immediate: true,
      handler () {
        if (this.expand) {
          this.active = true
        } else {
          this.active = false
        }
      }
    }
  },
  methods: {
    noop () {},
    getPotentialName (answers, firstNameOnly = false) {
      if (!answers) { return null }
      answers = Object.values(answers)
      // fullname
      let fullname = answers.find((answer) => {
        // console.log(answer.name)
        if (answer.name === 'fullname') { return answer }
      })
      // console.log(fullname)
      try {
        if (fullname) { return fullname.prettyFormat }
      } catch (err) { console.log(err) }

      let firstName = answers.find((answer) => {
        if (answer.name === 'first_name') { return answer }
        if (answer.name === 'firstName') { return answer }
        if (answer.name === 'name') { return answer }
        if (answer.name === 'patient_first_name') { return answer }
      })
      if (firstNameOnly) {
        if (firstName) { return firstName.answer }
        return ''
      }
      let lastName = answers.find((answer) => {
        if (answer.name === 'last_name') { return answer }
        if (answer.name === 'lastName') { return answer }
        if (answer.name === 'surname') { return answer }
        if (answer.name === 'patient_last_name') { return answer }
      })
      fullname = ''
      if (firstName) { fullname = firstName.answer }
      if (lastName) { fullname += ' ' + lastName.answer }
      return fullname
    }
  }
}
</script>



// WEBPACK FOOTER //
// SubmissionListItem.vue?f49e0d36